import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import Input from "../common/Input";
import toast from "react-hot-toast";

export default function VPApproveModal({
  open,
  onClose,
  onSubmit,
  requestData,
  isLoading = false,
}) {
  const [modifiedQuantity, setModifiedQuantity] = useState("");

  useEffect(() => {
    if (open && requestData) {
      setModifiedQuantity(requestData.requestedQty || "");
    }
  }, [open, requestData]);

  async function handleSubmit() {
    if (!modifiedQuantity || isLoading) return;
    
    const approvedQty = Number(modifiedQuantity);
    if (approvedQty <= 0 || approvedQty > requestData.requestedQty) {
      toast.error("Invalid approved quantity");
      return;
    }

    const deductedQty = requestData.requestedQty - approvedQty;

    try {
      await onSubmit?.(deductedQty);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[503px] pt-6 pb-11 px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-4 px-9">
          <div>
            <p className="text-xl leading-6 text-black font-bold">Approve Request</p>
            <p className="text-sm leading-4 text-black">VP Approval</p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-10 px-9 space-y-4">
          <div className="bg-[#F5F5F5] p-4 rounded-md mb-4 text-sm">
            <p><strong>Request ID:</strong> {requestData?._id}</p>
            <p><strong>Original Quantity:</strong> {requestData?.requestedQty}</p>
          </div>

          <Input
            type="number"
            label="Modify Quantity (Optional)"
            value={modifiedQuantity}
            onChange={(e) => setModifiedQuantity(e.target.value)}
            min="1"
            placeholder="Enter approved quantity"
          />

          <div className="mt-6 flex gap-3">
            <button
              onClick={onClose}
              className="w-full bg-[#E5E5E5] text-black py-3 font-bold text-sm rounded-[5px]"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={isLoading || !modifiedQuantity || Number(modifiedQuantity) <= 0}
              className="w-full bg-[#10A242] text-white py-3 font-bold text-sm rounded-[5px] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isLoading && <Loader />}
              {isLoading ? "Approving..." : "Approve & Send to Central"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
